import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import MainContainer from "../../components/MainContainer";
import SeoHead from "../../components/Seo/SeoHead.js";
import { featuredSeoArticles, seoArticles } from "../../seo/articles.js";
import {
  buildBreadcrumbSchema,
  buildItemListSchema,
  buildPageTitle,
  buildWebsiteSchema,
} from "../../seo/siteSeo.js";
import { selectLoggedIn } from "../../store/slices/auth/slice.js";
import { setSignUpModalOpen } from "../../store/slices/common/slice.js";
import {
  ActionRow,
  ArticleCard,
  ArticleExcerpt,
  ArticleGrid,
  ArticleMeta,
  ArticleTitleLink,
  CardLabel,
  Eyebrow,
  Hero,
  HeroCard,
  HeroCopy,
  Intro,
  KeywordList,
  Page,
  PrimaryAction,
  PrimaryActionButton,
  SecondaryAction,
  Title,
} from "../SeoArticlePage/SeoArticlePage.styles";

const SeoArticlesPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loggedIn = useSelector(selectLoggedIn);
  const primaryActionLabel = loggedIn ? "Open Fapify" : "Try Fapify Free";
  const featuredPaths = new Set(featuredSeoArticles.map((article) => article.path));
  const orderedArticles = [
    ...featuredSeoArticles,
    ...seoArticles.filter((article) => !featuredPaths.has(article.path)),
  ];

  const handleOpenProduct = () => {
    if (loggedIn) {
      navigate("/");
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
      return;
    }

    dispatch(setSignUpModalOpen(true));
  };

  const jsonLd = [
    buildWebsiteSchema(),
    buildBreadcrumbSchema([
      { name: "Home", path: "/" },
      { name: "Guides", path: "/blog" },
    ]),
    buildItemListSchema(
      orderedArticles.map((article) => ({
        name: article.h1,
        path: article.path,
      })),
    ),
  ];

  return (
    <MainContainer hideTabs={false} fullWidth>
      <SeoHead
        title={buildPageTitle(
          "AI Porn Generator Guides, NSFW AI Articles, and Workflow Tutorials",
        )}
        description="Browse Fapify guides covering best AI porn generator comparisons, NSFW AI workflows, AI porn image and video generation, nudify AI, and practical creation tutorials."
        path="/blog"
        keywords={[
          "ai porn generator guides",
          "best ai porn generator",
          "best nsfw ai",
          "nsfw ai articles",
          "ai porn image generator",
          "ai porn video generator",
          "nudify ai guide",
        ]}
        jsonLd={jsonLd}
      />

      <Page>
        <Hero>
          <HeroCopy>
            <Eyebrow>Fapify Content Hub</Eyebrow>
            <Title>AI Porn Generator Guides, NSFW AI Articles, and Tutorials</Title>
            <Intro>
              This hub collects Fapify guides for choosing the best AI porn
              generator, comparing NSFW AI workflows, improving AI porn image
              and video results, improving nudify AI workflows, and
              understanding the product paths behind the main search terms in
              this category.
            </Intro>
            <ActionRow>
              <PrimaryActionButton type="button" onClick={handleOpenProduct}>
                {primaryActionLabel}
              </PrimaryActionButton>
              <PrimaryAction to="/ai-porn-generator">AI Porn Generator</PrimaryAction>
              <SecondaryAction to="/">Explore Templates</SecondaryAction>
            </ActionRow>
          </HeroCopy>

          <HeroCard>
            <div>
              <CardLabel>What This Hub Covers</CardLabel>
              <KeywordList>
                <li>Best AI porn generator comparisons</li>
                <li>AI porn image and video workflows</li>
                <li>Nudify AI, AI nude, and undress AI guides</li>
                <li>NSFW AI art and still-image quality</li>
                <li>Quality fixes for still images and short clips</li>
              </KeywordList>
            </div>
          </HeroCard>
        </Hero>

        <ArticleGrid>
          {orderedArticles.map((article) => (
            <ArticleCard key={article.path}>
              <ArticleMeta>
                {article.readTime} · Updated {article.dateModified}
              </ArticleMeta>
              <ArticleTitleLink to={article.path}>{article.h1}</ArticleTitleLink>
              <ArticleExcerpt>{article.excerpt}</ArticleExcerpt>
              <SecondaryAction to={article.path}>Read Guide</SecondaryAction>
            </ArticleCard>
          ))}
        </ArticleGrid>
      </Page>
    </MainContainer>
  );
};

export default SeoArticlesPage;
